import { createFileRoute } from "@tanstack/react-router";
import { SectionPage } from "@/components/site/SectionPage";
import { fetchProducts } from "@/lib/products";

export const Route = createFileRoute("/women")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: ["products", "active"],
      queryFn: () => fetchProducts(),
    }),
  head: () => ({
    meta: [
      { title: "Women — KAKAIYS" },
      { name: "description", content: "Lambskin biker jackets, suede blazers, totes and clutches for women — hand-finished in our atelier." },
      { property: "og:title", content: "Women — KAKAIYS" },
      { property: "og:description", content: "Lambskin biker jackets, suede blazers, totes and clutches for women." },
      { name: "twitter:image", content: "https://tvmsfjwzfnidomctinqz.supabase.co/storage/v1/object/public/product-images/hover/noir-cropped-biker.png" },
      { property: "og:url", content: "https://kakaiys.com/women" },
    ],
      links: [{ rel: "canonical", href: "https://kakaiys.com/women" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Women — KAKAIYS",
          description: "Hand-finished leather jackets, bags, wallets and accessories for women.",
          url: "https://kakaiys.com/women",
          isPartOf: { "@id": "https://kakaiys.com/#website" },
          publisher: { "@id": "https://kakaiys.com/#organization" },
        }),
      },
    ],
  }),
  component: () => (
    <SectionPage
      eyebrow="Women"
      title="For Her."
      subtitle="The cropped biker, the long trench, the half-moon clutch. Pieces that move with you."
      filterTag="women"
    />
  ),
});
